// Generated by GitHub Copilot
import React from 'react';
import styles from './LeaderCard.module.css';

/**
 * LeaderCard displays a GCC leadership team member with their photo,
 * name (as a purple underlined link) and role title.
 *
 * @param {string} name     - Full name of the leader.
 * @param {string} role     - Job title / region lead.
 * @param {string} imgSrc   - URL for the leader's photo.
 * @param {string} imgAlt   - Descriptive alt text for the photo (accessibility).
 * @param {string} url      - URL for the leader's profile or more information.
 */
const LeaderCard = ({ name, role, imgSrc, imgAlt, url }) => {
  return (
    <article className={styles.card}>
      {/* Photo */}
      <div className={styles.photoWrapper}>
        <img
          src={imgSrc}
          alt={imgAlt}
          className={styles.photo}
          loading="lazy"
        />
      </div>

      {/* Name + Role overlay area */}
      <div className={styles.info}>
        <a
          href={url}
          className={styles.nameLink}
          aria-label={`Learn more about ${name}`}  target="_blank" rel="noopener noreferrer"
        >
          {name}
        </a>
        <p className={styles.role}>{role}</p>
      </div>
    </article>
  );
};

export default LeaderCard;
